import http from "@/http/http"

export interface IndustryClassifyVO {
  // 编码
  code: string
  // 标签
  label: string
}

// 根据沙盘类型获取品牌行业
export async function getIndustryByType(sandTableType: string): Promise<IndustryClassifyVO[]> {
  try {
    const result = await http.get<IndustryClassifyVO[]>(
      `/business/common/brandFirstType/${sandTableType}`,
    )
    return result?.data
  } catch (error) {
    throw error
  }
}

// 根据品牌行业获取品牌分类
export async function getClassifyByIndustry(brandFirstType: string): Promise<IndustryClassifyVO[]> {
  try {
    const result = await http.get<IndustryClassifyVO[]>(
      `/business/common/brandSecondType/${brandFirstType}`,
    )
    return result?.data
  } catch (error) {
    throw error
  }
}

export interface SearchBrandArgs {
  // 沙盘类型
  sandTableType: string
  // 品牌一级分类
  brandFirstType: string
  // 品牌二级分类
  brandSecondType: string
  // 品牌名称 支持模糊查询
  brandName: string
  // 是否已解锁 true - 已解锁； false - 未解锁； null - 全查
  unlocked: boolean | null
  // 每页条数
  pageSize?: number
  // 页数
  pageNum?: number
}

export interface SearchBrandVO {
  // 品牌ID
  brandId: string
  // 品牌名称
  brandName: string
  // 品牌logo地址
  logo: string
  // 品牌一级分类
  brandFirstType: string
  // 品牌二级分类
  brandSecondType: string
}

interface SearchBrandResult {
  rows: SearchBrandVO[]
  total: number
}

// 获取沙盘品牌列表
export async function searchBrandList(args: SearchBrandArgs): Promise<SearchBrandResult> {
  try {
    const { pageNum, pageSize, ...others } = args
    const param = pageNum && pageSize ? `?pageNum=${pageNum}&pageSize=${pageSize}` : ""
    const result = await http.post<SearchBrandResult>(`/business/common/brand/list${param}`, others)
    return result as any
  } catch (error) {
    throw error
  }
}

interface UpdateBrandArgs {
  sandTableId: string
  brandId: string
  brandName: string
}

// 切换沙盘品牌
export async function updateBrand(args: UpdateBrandArgs): Promise<boolean> {
  try {
    const { sandTableId, brandId, brandName } = args
    const result = await http.patch<boolean>(
      `/business/sandTable/${sandTableId}/brand?brandId=${brandId}&brandName=${brandName}`,
    )
    return result?.data
  } catch (error) {
    throw error
  }
}
